import { Chip } from "common";
import { Flex, SmallTile } from "lqx-react";
import * as React from "react";
import { PaymentRaLandingSummary } from "../../api/payments";
import { WidgetSmallLoading } from "../../common";
import { AutoReconciledPayments } from "./auto-reconciled-payments";

export const ReviewTiles = ({ $category, model }: { $category, model: PaymentRaLandingSummary }) =>
    <SmallTile
        color="red"
        $selected={$category.equals('auto-reconciled-payments')}
        right={<Chip color="yellow">{model.isReviewReady ? model.autoReconciledPayments.getCount() : <WidgetSmallLoading />}</Chip>}
        footer="Payments that were reconciled automatically by InBlock"
    >
        Auto Reconciled AR Payments
    </SmallTile>

export const ReviewDetails = ({ category, model }: { category: string, model: PaymentRaLandingSummary }) =>
    category === "auto-reconciled-payments"
        ? <AutoReconciledPayments state={model.autoReconciledPayments} />
        : <Flex center>
            <h2>Select the category on the left</h2>
        </Flex>
